/* eslint-disable no-underscore-dangle */
import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { Meteor } from 'meteor/meteor';
import { cloneDeep, forEach, get, isEmpty, isEqual, isNil } from 'lodash';
import { Bert } from 'meteor/themeteorchef:bert';
import uuid from 'uuid/v1';
import turf from '@turf/turf';

import * as mapOps from '../../../api/Maps/map-operations';
import * as layerOps from '../../../api/Layers/layer-operations';

import {
  featurePoint2LatLng,
  featureGetZoom,
  latlong2featurePoint,
  featureSetZoom,
  featureSetBBox
} from '../../../modules/geojson-utilities';
import handleErrorInClient from '../../../modules/handle-error-in-client';
import methodPromise from '../../../modules/method-promise-wrapper';

import ButtonOnMap from '../ButtonOnMap';
import LeafletMap from '../../components/LeafletMap';
import ExportProviderMap from '../../components/ExportProviderMap';

import * as annotationOps from '../../../api/Annotations/annotation-operations';

const { defaultMapCenter } = Meteor.settings.public;

let addDrawEventListenersMaps;
let arrayToSendCoordinates;
let circle;
let createGeometryDrawControlsMaps;
let customHomeButton;
let drawCustomButtons;
let drawMapInterestArea;
let drawMapLayers;
let estado = false;
let getBBoxFromCoordsAndZoom;
let getMapCenter;
let initializeLoaded = true;
let intervaloFunction;
let intervaloGoToFunction;
let L;
let lineTrackVideo;
let localforage;
let marker;
let markerAllAnnotations;
let markerAnnotations;
let markerAnnotationCLick;
let markerAnnotationsProyected;
let markerCoordVideoPoint;
let markerAnnotationImaps;
let markerDownload;
let manyMarkerAnnotationsClick;
const manyAnnotationClick = [];
let markersPolygonDownload = [];
const oldLayers = [];
const oldMap = [];
let sendCoordinates;
let showGeometryEditControls;
const timeCoordinates = 60;

class MapContainerViewMap extends Component {
  baseMapsToDisplay = null;

  layersToDisplay = null;

  aiInterestAreaDrawControl = null;

  aiInterestAreaEditControl = null;

  aiInterestAreaLayer = null;

  mapMap = null;

  mapMapComponent = React.createRef();

  randomMapId = uuid();

  state = {
    aiInterestArea: {},
    coordsAnnotationClick: {},
    clientModulesReady: false,
    isLeafletMapLoaded: get(this, 'mapMapComponent.current.state.isMapLoaded', false),
    isMapMapLoaded: false,
    currentLocationState: false,
    goToState: false,
    mapCenter: null
  };

  componentDidMount() {
    const { clientModulesReady } = this.state;
    if (!clientModulesReady) {
      this.loadClientModules();
    }
  }

  async componentDidUpdate(prevProps, prevState) {
    const {
      baseMaps,
      isAtlas,
      layers,
      map,
      updateLayerMapState,
      popupProp,
      leafletMapId,
      handleMapLoaded
    } = this.props;
    const {
      aiInterestArea,
      clientModulesReady,
      currentLocationState,
      goToState,
      isLeafletMapLoaded,
      isMapMapLoaded
    } = this.state;
    const { layers: prevLayers, baseMaps: prevBaseMaps, map: prevMap } = prevProps;
    const {
      currentLocationState: prevCurrentLocationState,
      aiInterestArea: prevAIInterestArea,
      goToState: prevGoToState
    } = prevState;
    let forceupdate = false;
    let forceupdateMap = false;
    let forceupdateLeafletButton = false;
    const hasSharedUpdated = mapOps.isShared(prevMap) !== mapOps.isShared(map);
    const hasMapCenterUpdated = !isEqual(
      mapOps.getMapLocation(prevMap),
      mapOps.getMapLocation(map)
    );
    const haveSelectedButtonsChanged = !isEqual(
      mapOps.getSelectedButtons(prevMap),
      mapOps.getSelectedButtons(map)
    );
    const areButtonsUpdated = hasSharedUpdated || hasMapCenterUpdated || haveSelectedButtonsChanged;

    if (clientModulesReady && isLeafletMapLoaded && !isMapMapLoaded && initializeLoaded) {
      initializeLoaded = false;
      if (leafletMapId.includes('imaps')) handleMapLoaded(false, {});
      this.initializeMap();
    }

    if (isMapMapLoaded && isLeafletMapLoaded) {
      this.mapMap.invalidateSize(true);
    }

    if (isMapMapLoaded && !isEqual(mapOps.getBackground(map), mapOps.getBackground(prevMap))) {
      const mapId = isAtlas ? this.randomMapId : leafletMapId;
      document.getElementById(mapId).style.background = mapOps.getBackground(map);
    }

    if (!isEqual(layers, oldLayers[0])) {
      forceupdate = true;
      oldLayers[0] = cloneDeep(layers);
    } else {
      forceupdate = false;
    }

    if (!isEqual(map, oldMap[0])) {
      forceupdateMap = true;
      oldMap[0] = cloneDeep(map);
    } else {
      forceupdateMap = false;
    }
    if (
      !isEqual(prevCurrentLocationState, currentLocationState) ||
      !isEqual(prevGoToState, goToState)
    ) {
      forceupdateLeafletButton = true;
    } else {
      forceupdateLeafletButton = false;
    }
    if (isMapMapLoaded) {
      estado =
        !isEqual(prevLayers, layers) ||
        !isEqual(prevBaseMaps, baseMaps) ||
        forceupdate === true ||
        forceupdateMap === true;
      if (estado === true) {
        const leafletObjectResults = await drawMapLayers({
          layers,
          baseMaps,
          popupProp,
          leafletMap: this.mapMap,
          layersOverlayed: mapOps.areLayersOverlayed(map),
          layersToDisplay: this.layersToDisplay,
          baseMapsToDisplay: this.baseMapsToDisplay,
          isUpdate: true,
          baseMapsTransparency: mapOps.getBaseMapsTransparency(map),
          layersTransparency: mapOps.getLayersTransparency(map),
          baseMapsZoom: mapOps.getBaseMapsZoom(map),
          layersZoom: mapOps.getLayersZoom(map)
        });
        this.layersToDisplay = leafletObjectResults.newLayersToDraw;
        this.baseMapsToDisplay = leafletObjectResults.newBaseMapsToDraw;
        drawCustomButtons({
          map,
          type: 'map',
          leafletMap: this.mapMap,
          layers,
          layersToDisplay: this.layersToDisplay,
          baseMaps,
          baseMapsToDisplay: this.baseMapsToDisplay,
          baseMapsZoom: mapOps.getBaseMapsZoom(map),
          layersZoom: mapOps.getLayersZoom(map),
          reloadButton: true,
          reloadFunction: this.reloadMap,
          locationButton: true,
          currentLocationState,
          locationFunction: this.currentLocation,
          goToState,
          gotoLocationButton: true,
          gotoLocationFunction: this.gotoLocation
        });
        drawMapInterestArea({
          aiInterestArea,
          aiInterestAreaLayer: this.aiInterestAreaLayer,
          isUpdate: true,
          leafletMap: this.mapMap
        });
        if (!isEmpty(aiInterestArea)) {
          this.mapMap.removeControl(this.aiInterestAreaDrawControl);
        }
        if (mapOps.showDrawControl(map)) {
          showGeometryEditControls({
            leafletMap: this.mapMap,
            drawControl: this.aiInterestAreaDrawControl,
            editControl: this.aiInterestAreaEditControl,
            defineGeometryActive: true,
            geometryLayer: this.aiInterestAreaLayer
          });
        }

        updateLayerMapState(false);
      } else if (areButtonsUpdated || forceupdateLeafletButton === true) {
        drawCustomButtons({
          map,
          type: 'map',
          leafletMap: this.mapMap,
          layers,
          layersToDisplay: this.layersToDisplay,
          baseMaps,
          baseMapsToDisplay: this.baseMapsToDisplay,
          baseMapsZoom: mapOps.getBaseMapsZoom(map),
          layersZoom: mapOps.getLayersZoom(map),
          reloadButton: true,
          reloadFunction: this.reloadMap,
          locationButton: true,
          locationFunction: this.currentLocation,
          goToState,
          gotoLocationButton: true,
          gotoLocationFunction: this.gotoLocation,
          currentLocationState
        });
      }
      if (
        (!isEqual(aiInterestArea, prevAIInterestArea) || forceupdateLeafletButton === true) &&
        estado === false
      ) {
        drawMapInterestArea({
          aiInterestArea,
          aiInterestAreaLayer: this.aiInterestAreaLayer,
          isUpdate: true,
          leafletMap: this.mapMap
        });
        if (!isEmpty(aiInterestArea)) {
          this.mapMap.removeControl(this.aiInterestAreaDrawControl);
        }
        if (mapOps.showDrawControl(map)) {
          showGeometryEditControls({
            leafletMap: this.mapMap,
            drawControl: this.aiInterestAreaDrawControl,
            editControl: this.aiInterestAreaEditControl,
            defineGeometryActive: true,
            geometryLayer: this.aiInterestAreaLayer
          });
        }

        this.expandirDesplegable();
      }
    }
    this.createMapCenter();
  }

  componentWillUnmount() {
    const { layers, baseMaps } = this.props;

    forEach(layers, layer => {
      if (layerOps.isRealTime(layer) || layerOps.isAnnotationsRealTime(layer)) {
        this.layersToDisplay[layerOps.getName(layer)].stop();
      }
    });

    forEach(baseMaps, baseMap => {
      if (layerOps.isRealTime(baseMap)) {
        this.baseMapsToDisplay[layerOps.getName(baseMap)].stop();
      }
    });
  }

  createMapCenter = () => {
    const { map } = this.props;
    const { isMapMapLoaded } = this.state;
    if (isEmpty(mapOps.getMapLocation(map)) && isMapMapLoaded) {
      this.updateMapCenter();
    }
  };

  getCurrentMapState = () => {
    return {
      itemType: 'leafletMap',
      leafletMap: this.mapMap,
      defineGeometryActive: true,
      geometryLayer: this.aiInterestAreaLayer,
      drawControl: this.aiInterestAreaDrawControl,
      editControl: this.aiInterestAreaEditControl,
      setAtlasGeometry: this.setAIInterestArea
    };
  };

  setAIInterestArea = newAIInterestArea => this.setState({ aiInterestArea: newAIInterestArea });

  updateMapState = newState => {
    this.setState({ isLeafletMapLoaded: newState });
  };

  updateMapCenter = async () => {
    const { isMapMapLoaded } = this.state;
    const { map } = this.props;
    if (isMapMapLoaded) {
      const currentMapCenter = latlong2featurePoint(this.mapMap.getCenter().wrap());
      featureSetZoom(currentMapCenter, this.mapMap.getZoom());
      featureSetBBox(
        currentMapCenter,
        getBBoxFromCoordsAndZoom({ map: this.mapMap, mapLocation: currentMapCenter })
      );
      try {
        await methodPromise('maps.updateMapLocation', mapOps.getId(map), currentMapCenter);
        if (mapOps.showHomeButton(map)) {
          this.mapMap.removeControl(this.mapMap.homeButton);
          customHomeButton(this.mapMap, currentMapCenter);
        }
        Bert.alert('Map Updated!', 'success');
      } catch (error) {
        handleErrorInClient(error);
      }
    } else {
      Bert.alert('Map Not Loaded!', 'warning');
    }
  };

  expandirDesplegable = () => {
    this.mapMap.collapseButton.expand();
  };

  locationList = async () => {
    const { map } = this.props;

    localforage.getItem(`userLocation`).then(geojsonContent => {
      const arrayLocal = isEmpty(geojsonContent) ? [] : JSON.parse(geojsonContent);
      navigator.geolocation.getCurrentPosition(position => {
        const coordinates = [position.coords.latitude, position.coords.longitude];
        const newCoordinates = {
          coordinates,
          loginId: isEmpty(arrayLocal) ? uuid() : arrayLocal[arrayLocal.length - 1].loginId,
          mapId: map._id,
          mapName: map.name,
          key: uuid(),
          userId: map.owner,
          time: `${`${new Date().getDate()}-${new Date().getMonth() +
            1}-${new Date().getFullYear()}` +
            ' '}${new Date().getHours()}:${new Date().getMinutes()}:${new Date().getSeconds()}`
        };
        sendCoordinates = [newCoordinates];
        if (isEmpty(arrayToSendCoordinates)) {
          arrayToSendCoordinates = [newCoordinates];
        } else {
          arrayToSendCoordinates.push(newCoordinates);
        }
        const allCoordinates = [...arrayLocal, newCoordinates];
        localforage.setItem(`userLocation`, JSON.stringify(allCoordinates));
      });
    });
    if (timeCoordinates > 20) {
      try {
        if (!isEmpty(sendCoordinates)) {
          await methodPromise('maps.sendUserLocation', { userLocation: sendCoordinates });
          sendCoordinates = [];
        }
      } catch (error) {
        handleErrorInClient(error);
      }
    }
  };

  sendUserLocation = async () => {
    if (!isEmpty(sendCoordinates)) {
      try {
        await methodPromise('maps.sendUserLocation', { userLocation: arrayToSendCoordinates });
      } catch (error) {
        handleErrorInClient(error);
      }
    }
    arrayToSendCoordinates = [];
  };

  calculateDrawGoToLocation = pos => {
    const radius = pos.coords.accuracy;
    marker = L.marker([pos.coords.latitude, pos.coords.longitude]).addTo(this.mapMap);
    circle = L.circle([pos.coords.latitude, pos.coords.longitude], radius, {
      color: 'blue',
      fillColor: 'blue'
    }).addTo(this.mapMap);
    this.mapMap.panTo([pos.coords.latitude, pos.coords.longitude]);
    intervaloGoToFunction = setInterval(this.actualizarGoToFunction, 5000);
  };

  actualizarGoToFunction = () => {
    const error = err => {
      console.warn(`ERROR(${err.code}): ${err.message}`);
    };
    const options = {
      enableHighAccuracy: false,
      timeout: 5000,
      maximumAge: 5000
    };
    navigator.geolocation.getCurrentPosition(this.calculateUpateGoTo, error, options);
  };

  calculateUpateGoTo = pos => {
    if (!isEmpty(marker)) {
      const from = turf.point([pos.coords.longitude, pos.coords.latitude]);
      const to = turf.point([marker._latlng.lng, marker._latlng.lat]);
      const options = { units: 'meters' };
      const distance = turf.distance(from, to, options);

      if (distance > 8) {
        this.mapMap.removeLayer(marker);
        this.mapMap.removeLayer(circle);
        const radius = pos.coords.accuracy;
        marker = L.marker([pos.coords.latitude, pos.coords.longitude]).addTo(this.mapMap);
        circle = L.circle([pos.coords.latitude, pos.coords.longitude], radius, {
          color: 'blue',
          fillColor: 'blue'
        }).addTo(this.mapMap);
        this.mapMap.panTo([pos.coords.latitude, pos.coords.longitude]);
      }
    }
  };

  gotoLocation = () => {
    const { currentLocationState, goToState, isMapMapLoaded } = this.state;

    const error = err => {
      console.warn(`ERROR(${err.code}): ${err.message}`);
    };
    const options = {
      enableHighAccuracy: false,
      // timeout: 5000,
      maximumAge: 5000
    };
    if (isMapMapLoaded) {
      if (goToState === false) {
        if (currentLocationState === true) {
          this.mapMap.removeLayer(marker);
          this.mapMap.removeLayer(circle);
          clearInterval(intervaloFunction);
          this.setState({ currentLocationState: false });
        }
        navigator.geolocation.getCurrentPosition(this.calculateDrawGoToLocation, error, options);
      } else {
        this.mapMap.removeLayer(marker);
        this.mapMap.removeLayer(circle);
        clearInterval(intervaloGoToFunction);
      }
    }
    this.setState({ goToState: !goToState });
  };

  calculateDrawLocation = pos => {
    const radius = pos.coords.accuracy;
    marker = L.marker([pos.coords.latitude, pos.coords.longitude]).addTo(this.mapMap);
    circle = L.circle([pos.coords.latitude, pos.coords.longitude], radius, {
      color: 'blue',
      fillColor: 'blue'
    }).addTo(this.mapMap);
    intervaloFunction = setInterval(this.actualizarFunction, 5000);
  };

  actualizarFunction = () => {
    const error = err => {
      console.warn(`ERROR(${err.code}): ${err.message}`);
    };
    const options = {
      enableHighAccuracy: false,
      // timeout: 5000,
      maximumAge: 5000
    };
    navigator.geolocation.getCurrentPosition(this.calculateUpate, error, options);
  };

  calculateUpate = pos => {
    if (!isEmpty(marker)) {
      const from = turf.point([pos.coords.longitude, pos.coords.latitude]);
      const to = turf.point([marker._latlng.lng, marker._latlng.lat]);
      const options = { units: 'meters' };
      const distance = turf.distance(from, to, options);

      if (distance > 8) {
        this.mapMap.removeLayer(marker);
        this.mapMap.removeLayer(circle);
        const radius = pos.coords.accuracy;
        marker = L.marker([pos.coords.latitude, pos.coords.longitude]).addTo(this.mapMap);
        circle = L.circle([pos.coords.latitude, pos.coords.longitude], radius, {
          color: 'blue',
          fillColor: 'blue'
        }).addTo(this.mapMap);
      }
    }
  };

  currentLocation = () => {
    const { currentLocationState, goToState, isMapMapLoaded } = this.state;
    const error = err => {
      console.warn(`ERROR(${err.code}): ${err.message}`);
    };
    const options = {
      enableHighAccuracy: false,
      // timeout: 5000,
      maximumAge: 5000
    };

    if (isMapMapLoaded) {
      if (currentLocationState === false) {
        if (goToState === true) {
          this.mapMap.removeLayer(marker);
          this.mapMap.removeLayer(circle);
          clearInterval(intervaloGoToFunction);
          this.setState({ goToState: false });
        }
        navigator.geolocation.getCurrentPosition(this.calculateDrawLocation, error, options);
        this.setState({ currentLocationState: true });
      } else {
        this.mapMap.removeLayer(marker);
        this.mapMap.removeLayer(circle);
        clearInterval(intervaloFunction);
      }
    }
    this.setState({ currentLocationState: !currentLocationState });
  };

  drawGeometriesNotes = (
    allCoordsAnnotations,
    coordinatesAnnotations,
    checkCenterAnnotation,
    coordOnMap,
    coordinatesTrackVideo,
    isNotesVideoEditor,
    setCoordOnMap,
    setCoordinatesAnnotations,
    setProyectedPointTrackVideo,
    coordinatesVideoPoint
  ) => {
    const { leafletMapId } = this.props;
    if (!leafletMapId.includes('imaps')) {
      const greenIcon = new L.Icon({
        iconUrl:
          'https://raw.githubusercontent.com/pointhi/leaflet-color-markers/master/img/marker-icon-2x-green.png',
        shadowUrl: 'https://cdnjs.cloudflare.com/ajax/libs/leaflet/0.7.7/images/marker-shadow.png',
        iconSize: [25, 41],
        iconAnchor: [12, 41],
        popupAnchor: [1, -34],
        shadowSize: [41, 41]
      });
      const orangeIcon = new L.Icon({
        iconUrl:
          'https://raw.githubusercontent.com/pointhi/leaflet-color-markers/master/img/marker-icon-2x-orange.png',
        shadowUrl: 'https://cdnjs.cloudflare.com/ajax/libs/leaflet/0.7.7/images/marker-shadow.png',
        iconSize: [25, 41],
        iconAnchor: [12, 41],
        popupAnchor: [1, -34],
        shadowSize: [41, 41]
      });
      const redIcon = new L.Icon({
        iconUrl:
          'https://raw.githubusercontent.com/pointhi/leaflet-color-markers/master/img/marker-icon-2x-red.png',
        shadowUrl: 'https://cdnjs.cloudflare.com/ajax/libs/leaflet/0.7.7/images/marker-shadow.png',
        iconSize: [25, 41],
        iconAnchor: [12, 41],
        popupAnchor: [1, -34],
        shadowSize: [41, 41]
      });
      const yellowIcon = new L.Icon({
        iconUrl:
          'https://raw.githubusercontent.com/pointhi/leaflet-color-markers/master/img/marker-icon-2x-yellow.png',
        shadowUrl: 'https://cdnjs.cloudflare.com/ajax/libs/leaflet/0.7.7/images/marker-shadow.png',
        iconSize: [25, 41],
        iconAnchor: [12, 41],
        popupAnchor: [1, -34],
        shadowSize: [41, 41]
      });
      const blueIcon = new L.Icon({
        iconUrl:
          'https://raw.githubusercontent.com/pointhi/leaflet-color-markers/master/img/marker-icon-2x-blue.png',
        shadowUrl: 'https://cdnjs.cloudflare.com/ajax/libs/leaflet/0.7.7/images/marker-shadow.png',
        iconSize: [25, 41],
        iconAnchor: [12, 41],
        popupAnchor: [1, -34],
        shadowSize: [41, 41]
      });
      if (!isEmpty(manyMarkerAnnotationsClick)) {
        manyMarkerAnnotationsClick.map(element => {
          return this.mapMap.removeLayer(element);
        });
      }

      if (!isEmpty(markerAnnotationsProyected)) {
        this.mapMap.removeLayer(markerAnnotationsProyected);
      }
      if (!isEmpty(markerAnnotations)) {
        this.mapMap.removeLayer(markerAnnotations);
      }

      if (!isEmpty(lineTrackVideo)) {
        this.mapMap.removeLayer(lineTrackVideo);
      }

      if (!isEmpty(markerAllAnnotations)) {
        markerAllAnnotations.map(element => {
          return this.mapMap.removeLayer(element);
        });
      }

      if (!isEmpty(markerCoordVideoPoint)) {
        this.mapMap.removeLayer(markerCoordVideoPoint);
      }

      const addPointOnMapNotes = e => {
        const { lat } = e.latlng;
        const { lng } = e.latlng;
        const newPointTrack = [lat, lng];
        if (!isEmpty(markerAnnotationCLick)) {
          this.mapMap.removeLayer(markerAnnotationCLick);
        }
        if (!isEmpty(markerAnnotationsProyected)) {
          this.mapMap.removeLayer(markerAnnotationsProyected);
        }
        markerAnnotationCLick = L.marker(newPointTrack, { icon: redIcon })
          .bindPopup('New point create annotation')
          .openPopup()
          .addTo(this.mapMap);
        if (!isEmpty(newPointTrack)) {
          setCoordOnMap({ lat, lng });
          this.setState({ coordsAnnotationClick: { lat, lng } });
        }
        if (!isEmpty(newPointTrack) && !isEmpty(coordinatesTrackVideo)) {
          const turfLine = turf.lineString(coordinatesTrackVideo);
          const newPointTurf = turf.point([lng, lat]);
          const newPointVideo = turf.nearestPointOnLine(turfLine, newPointTurf);
          const { coordinates } = newPointVideo.geometry;
          markerAnnotationsProyected = L.marker([coordinates[1], coordinates[0]], {
            icon: yellowIcon
          }).addTo(this.mapMap);
          setProyectedPointTrackVideo(newPointVideo);
        }
      };

      if (checkCenterAnnotation === true) {
        if (!isEmpty(allCoordsAnnotations)) {
          markerAllAnnotations = allCoordsAnnotations.map(element => {
            const geoJson = annotationOps.getGeoJSON(element);
            const { coordinates } = geoJson.geometry;
            const long = coordinates[0];
            const lat = coordinates[1];
            return L.marker([lat, long], { icon: orangeIcon }).addTo(this.mapMap);
          });
          markerAllAnnotations.forEach((element, index) => {
            element.on('click', () => {
              setCoordinatesAnnotations(allCoordsAnnotations[index]);
            });
          });
        }
        if (!isEmpty(coordinatesAnnotations)) {
          const geoJsonAnnotation = annotationOps.getGeoJSON(coordinatesAnnotations);
          const { coordinates } = geoJsonAnnotation.geometry;
          const longAnnotation = coordinates[0];
          const latAnnotation = coordinates[1];
          markerAnnotations = L.marker([latAnnotation, longAnnotation], {
            icon: greenIcon
          })
            .bindPopup(`Annotation`)
            .openPopup()
            .addTo(this.mapMap, this.mapMap.getZoom());
          this.mapMap.setView([latAnnotation, longAnnotation]);
        }
        if (!isEmpty(coordinatesTrackVideo)) {
          const coordsLatLong = [];
          for (let i = 0; i < coordinatesTrackVideo.length; i += 1) {
            const longlatArray = coordinatesTrackVideo[i];
            const long = longlatArray[0];
            const lat = longlatArray[1];
            coordsLatLong.push([lat, long]);
          }
          lineTrackVideo = L.polyline([coordsLatLong], {
            color: 'blue'
          }).addTo(this.mapMap, this.mapMap.getZoom());
          if (isEmpty(coordinatesAnnotations)) this.mapMap.setView(coordsLatLong[0]);
        }
        if (!isEmpty(coordinatesVideoPoint)) {
          const videoPoint = [coordinatesVideoPoint.lat, coordinatesVideoPoint.lng];
          markerCoordVideoPoint = L.marker(videoPoint, {
            icon: blueIcon
          }).addTo(this.mapMap, this.mapMap.getZoom());
          if (isEmpty(coordinatesAnnotations)) this.mapMap.setView(videoPoint);
        }
      } else {
        setCoordOnMap({});
        setProyectedPointTrackVideo({});
        manyAnnotationClick.splice(0, manyAnnotationClick.length);
        this.setState({ coordsAnnotationClick: {} });
        if (!isEmpty(markerAllAnnotations)) {
          markerAllAnnotations.map(element => {
            return this.mapMap.removeLayer(element);
          });
        }
      }

      if (isNotesVideoEditor === 'create' || isNotesVideoEditor === 'import-anyJson') {
        const { coordsAnnotationClick } = this.state;
        if (!isEmpty(coordsAnnotationClick)) {
          const { lat } = coordsAnnotationClick;
          const { lng } = coordsAnnotationClick;
          manyAnnotationClick.push([lat, lng]);
        }
        if (manyAnnotationClick.length > 0) {
          manyMarkerAnnotationsClick = manyAnnotationClick.map(element => {
            return L.marker(element, { icon: redIcon })
              .bindPopup('Annotation Maps point')
              .openPopup()
              .addTo(this.mapMap);
          });
        }
        this.mapMap.on('click', addPointOnMapNotes);
      }
      if (isNotesVideoEditor === 'close') {
        manyAnnotationClick.splice(0, manyAnnotationClick.length);
        if (!isEmpty(manyMarkerAnnotationsClick)) {
          manyMarkerAnnotationsClick.map(element => {
            return this.mapMap.removeLayer(element);
          });
        }
        if (!isEmpty(markerAnnotationCLick)) {
          this.mapMap.removeLayer(markerAnnotationCLick);
        }
        setCoordOnMap({});
        setProyectedPointTrackVideo({});
        this.setState({ coordsAnnotationClick: {} });
        this.mapMap.off('click');
      }

      if (isNotesVideoEditor === 'import-annotation') {
        if (!isEmpty(coordOnMap)) {
          const { lat } = coordOnMap;
          const { lng } = coordOnMap;
          const newPointTrack = [lat, lng];
          markerAnnotationCLick = L.marker(newPointTrack, { icon: redIcon })
            .bindPopup('Annotation Maps point')
            .openPopup()
            .addTo(this.mapMap);

          if (!isEmpty(coordinatesTrackVideo)) {
            const turfLine = turf.lineString(coordinatesTrackVideo);
            const newPointTurf = turf.point([lng, lat]);
            const newPointVideo = turf.nearestPointOnLine(turfLine, newPointTurf);
            const { coordinates } = newPointVideo.geometry;
            markerAnnotationsProyected = L.marker([coordinates[1], coordinates[0]], {
              icon: yellowIcon
            }).addTo(this.mapMap);
            setProyectedPointTrackVideo(newPointVideo);
          }
        }
      }
    }
  };

  drawGeometriesTemplates = coordsAnnotationTemplate => {
    const { leafletMapId } = this.props;
    if (leafletMapId.includes('imaps')) {
      const greenIcon = new L.Icon({
        iconUrl:
          'https://raw.githubusercontent.com/pointhi/leaflet-color-markers/master/img/marker-icon-2x-green.png',
        shadowUrl: 'https://cdnjs.cloudflare.com/ajax/libs/leaflet/0.7.7/images/marker-shadow.png',
        iconSize: [25, 41],
        iconAnchor: [12, 41],
        popupAnchor: [1, -34],
        shadowSize: [41, 41]
      });

      if (!isEmpty(markerAnnotationImaps)) {
        this.mapMap.removeLayer(markerAnnotationImaps);
      }

      if (!isEmpty(coordsAnnotationTemplate)) {
        const geoJsonAnnotation = annotationOps.getGeoJSON(coordsAnnotationTemplate);
        const { coordinates } = geoJsonAnnotation.geometry;
        const longAnnotation = coordinates[0];
        const latAnnotation = coordinates[1];
        markerAnnotationImaps = L.marker([latAnnotation, longAnnotation], {
          icon: greenIcon
        })
          .bindPopup(`Annotation IMAPS`)
          .openPopup()
          .addTo(this.mapMap, this.mapMap.getZoom());
      }
    }
  };

  drawToDownload = ({ setCoordOnMap, geometryConfig, setDataToSend }) => {
    const redIcon = new L.Icon({
      iconUrl:
        'https://raw.githubusercontent.com/pointhi/leaflet-color-markers/master/img/marker-icon-2x-red.png',
      shadowUrl: 'https://cdnjs.cloudflare.com/ajax/libs/leaflet/0.7.7/images/marker-shadow.png',
      iconSize: [25, 41],
      iconAnchor: [12, 41],
      popupAnchor: [1, -34],
      shadowSize: [41, 41]
    });
    const yellowIcon = new L.Icon({
      iconUrl:
        'https://raw.githubusercontent.com/pointhi/leaflet-color-markers/master/img/marker-icon-2x-yellow.png',
      shadowUrl: 'https://cdnjs.cloudflare.com/ajax/libs/leaflet/0.7.7/images/marker-shadow.png',
      iconSize: [25, 41],
      iconAnchor: [12, 41],
      popupAnchor: [1, -34],
      shadowSize: [41, 41]
    });

    const blueIcon = new L.Icon({
      iconUrl:
        'https://raw.githubusercontent.com/pointhi/leaflet-color-markers/master/img/marker-icon-2x-blue.png',
      shadowUrl: 'https://cdnjs.cloudflare.com/ajax/libs/leaflet/0.7.7/images/marker-shadow.png',
      iconSize: [25, 41],
      iconAnchor: [12, 41],
      popupAnchor: [1, -34],
      shadowSize: [41, 41]
    });

    const addPointOnMap = e => {
      if (!isEmpty(markerDownload)) {
        this.mapMap.removeLayer(markerDownload);
      }
      if (geometryConfig === 'punto') {
        const { lat } = e.latlng;
        const { lng } = e.latlng;
        setCoordOnMap({ lat, lng });
      } else if (geometryConfig === 'StreetView') {
        const { lat } = e.latlng;
        const { lng } = e.latlng;
        setCoordOnMap({ lat, lng });
        markerDownload = L.marker([lat, lng], { icon: redIcon })
          .bindPopup('Street view point')
          .openPopup()
          .addTo(this.mapMap);
      } else if (geometryConfig === 'directButton') {
        const { lat } = e.latlng;
        const { lng } = e.latlng;
        setCoordOnMap({ lat, lng });
        markerDownload = L.marker([lat, lng], { icon: blueIcon })
          .bindPopup('Last annotation')
          .openPopup()
          .addTo(this.mapMap);
      } else if (geometryConfig === 'otros' || geometryConfig === 'catastro') {
        const { lat } = e.latlng;
        const { lng } = e.latlng;
        setDataToSend({ lat, lng });
      } else if (geometryConfig === 'sentinel') {
        if (markersPolygonDownload.length === 0) {
          const popupContent = 'Clickea en otra zona para crear un rectángulo';
          const popup = L.popup({ autoClose: false, closeOnClick: false }).setContent(popupContent);
          marker = L.marker(e.latlng, { icon: yellowIcon }).addTo(this.mapMap);
          marker.bindPopup(popup);
          marker.openPopup();
          markersPolygonDownload.push(marker);
        } else if (markersPolygonDownload.length === 1) {
          const secondmarker = L.marker(e.latlng, { icon: yellowIcon }).addTo(this.mapMap);
          markersPolygonDownload.push(secondmarker);

          const polygonCoordinates = markersPolygonDownload.map(element => {
            const coordenadas = element.getLatLng();
            return [coordenadas.lat, coordenadas.lng];
          });
          const polygonGeometry = L.rectangle(polygonCoordinates, {
            color: 'blue',
            fillOpacity: 0.3,
            pane: '1000'
          });
          setDataToSend(polygonCoordinates);
          markerDownload = polygonGeometry.addTo(this.mapMap);
          markersPolygonDownload.map(element => this.mapMap.removeLayer(element));
          if (!isEmpty(markersPolygonDownload)) {
            markersPolygonDownload = [];
          }
        }
      } else if (geometryConfig === 'poligono') {
        if (markersPolygonDownload.length === 0) {
          const popupContent = 'Clickear este primer punto para cerrar el polígono';
          const popup = L.popup({ autoClose: false, closeOnClick: false }).setContent(popupContent);
          marker = L.marker(e.latlng, { icon: yellowIcon }).addTo(this.mapMap);
          marker.bindPopup(popup);
          marker.openPopup();
        } else {
          marker = L.marker(e.latlng, { icon: yellowIcon }).addTo(this.mapMap);
        }
        markersPolygonDownload.push(marker);
        if (markersPolygonDownload.length >= 3) {
          markersPolygonDownload.forEach((item, index) => {
            item.on('click', () => {
              if (index === 0) {
                item.off('click');
                const polygonCoordinates = markersPolygonDownload.map(element => {
                  const coordenadas = element.getLatLng();
                  return [coordenadas.lat, coordenadas.lng];
                });
                setDataToSend(polygonCoordinates);
                const polygonGeometry = L.polygon(polygonCoordinates, {
                  color: 'blue',
                  fillOpacity: 0.3,
                  pane: '1000'
                });
                markerDownload = polygonGeometry.addTo(this.mapMap);
                markersPolygonDownload.map(element => this.mapMap.removeLayer(element));
                if (!isEmpty(markersPolygonDownload)) {
                  markersPolygonDownload = [];
                }
              }
            });
          });
        }
      }
    };
    if (!isEmpty(markerDownload)) {
      this.mapMap.removeLayer(markerDownload);
      markerDownload = {};
    }
    if (!isEmpty(markersPolygonDownload)) {
      markersPolygonDownload.map(element => this.mapMap.removeLayer(element));
      markersPolygonDownload = [];
    }
    if (
      geometryConfig === 'punto' ||
      geometryConfig === 'otros' ||
      geometryConfig === 'catastro' ||
      geometryConfig === 'StreetView' ||
      geometryConfig === 'directButton'
    ) {
      this.mapMap.off('click');
      this.mapMap.on('click', addPointOnMap);
    } else if (geometryConfig === 'poligono' || geometryConfig === 'sentinel') {
      this.mapMap.off('click');
      this.mapMap.on('click', addPointOnMap);
    } else if (geometryConfig === 'none' || geometryConfig === 'component') {
      this.mapMap.off('click');
    }
  };

  goToCoordinatesFunction = ({ geometryConfig, goToCoordinates, setGoToCoordinates }) => {
    const orangeIcon = new L.Icon({
      iconUrl:
        'https://raw.githubusercontent.com/pointhi/leaflet-color-markers/master/img/marker-icon-2x-orange.png',
      shadowUrl: 'https://cdnjs.cloudflare.com/ajax/libs/leaflet/0.7.7/images/marker-shadow.png',
      iconSize: [25, 41],
      iconAnchor: [12, 41],
      popupAnchor: [1, -34],
      shadowSize: [41, 41]
    });
    if (
      goToCoordinates[0] !== 0 &&
      goToCoordinates[1] !== 0 &&
      typeof goToCoordinates[0] === 'number' &&
      typeof goToCoordinates[1] === 'number'
    ) {
      if (
        geometryConfig === 'punto' ||
        geometryConfig === 'otros' ||
        geometryConfig === 'catastro' ||
        geometryConfig === 'input'
      ) {
        if (!isEmpty(markerDownload)) {
          this.mapMap.removeLayer(markerDownload);
          markerDownload = {};
        }
        markerDownload = L.marker(goToCoordinates, { icon: orangeIcon }).addTo(this.mapMap);
      }
      this.mapMap.flyTo(goToCoordinates);

      setGoToCoordinates([0, 0]);
    }
  };

  initializeMap = async () => {
    const {
      baseMaps,
      isAtlas,
      layers,
      map,
      updateLayerMapState,
      popupProp,
      externalBoton,
      updateLocation,
      userControlSetting,
      leafletMapId,
      handleMapLoaded
    } = this.props;
    const { aiInterestArea, currentLocationState, goToState } = this.state;
    let mapLocation = mapOps.getMapLocation(map);
    if (isEmpty(mapLocation)) {
      if (!isNil(Meteor.user())) {
        mapLocation = userControlSetting.defaultMapCenter;
      } else {
        mapLocation = defaultMapCenter;
      }
    }

    this.mapMap = get(this, 'mapMapComponent.current.leafletMap');
    this.mapMap.setView(
      featurePoint2LatLng(getMapCenter({ location: mapLocation })),
      featureGetZoom(mapLocation)
    );

    const mapId = isAtlas ? this.randomMapId : leafletMapId;
    document.getElementById(mapId).style.background = mapOps.getBackground(map);
    const leafletObjectResults = await drawMapLayers({
      layers,
      baseMaps,
      popupProp,
      leafletMap: this.mapMap,
      layersOverlayed: mapOps.areLayersOverlayed(map),
      layersToDisplay: this.layersToDisplay,
      baseMapsToDisplay: this.baseMapsToDisplay,
      baseMapsTransparency: mapOps.getBaseMapsTransparency(map),
      layersTransparency: mapOps.getLayersTransparency(map),
      baseMapsZoom: mapOps.getBaseMapsZoom(map),
      layersZoom: mapOps.getLayersZoom(map)
    });
    this.layersToDisplay = leafletObjectResults.newLayersToDraw;
    this.baseMapsToDisplay = leafletObjectResults.newBaseMapsToDraw;
    drawCustomButtons({
      map,
      type: 'map',
      leafletMap: this.mapMap,
      layers,
      layersToDisplay: this.layersToDisplay,
      baseMaps,
      baseMapsToDisplay: this.baseMapsToDisplay,
      baseMapsZoom: mapOps.getBaseMapsZoom(map),
      layersZoom: mapOps.getLayersZoom(map),
      reloadButton: true,
      reloadFunction: this.reloadMap,
      locationButton: true,
      currentLocationState,
      locationFunction: this.currentLocation,
      goToState,
      gotoLocationButton: true,
      gotoLocationFunction: this.gotoLocation
    });
    this.aiInterestAreaLayer = drawMapInterestArea({
      aiInterestArea,
      leafletMap: this.mapMap
    });

    const aiInterestAreaControls = createGeometryDrawControlsMaps({
      drawnItems: this.aiInterestAreaLayer
    });
    this.aiInterestAreaDrawControl = aiInterestAreaControls.drawControlFull;
    this.aiInterestAreaEditControl = aiInterestAreaControls.drawControlEdit;

    addDrawEventListenersMaps({
      limitation: false,
      // maximumarea: this.state.maximumarea,
      leafletMap: this.mapMap,
      getCurrentMapState: this.getCurrentMapState,
      editControl: this.aiInterestAreaEditControl
    });
    if (mapOps.showDrawControl(map)) {
      showGeometryEditControls({
        leafletMap: this.mapMap,
        drawControl: this.aiInterestAreaDrawControl,
        editControl: this.aiInterestAreaEditControl,
        defineGeometryActive: true,
        geometryLayer: this.aiInterestAreaLayer
      });
    }

    this.mapMap.on('moveend', () => {
      const currentMapCenter = this.mapMap.getCenter().wrap();
      currentMapCenter.zoom = this.mapMap.getZoom();
      if (!externalBoton) {
        updateLocation(currentMapCenter);
      }
      this.setState({ mapCenter: currentMapCenter });
    });
    this.setState({ isMapMapLoaded: true });
    initializeLoaded = true;
    updateLayerMapState(false);
    if (leafletMapId.includes('imaps')) {
      handleMapLoaded(true, this.mapMap);
    }
    // setInterval(() => {
    //   this.locationList();
    // }, timeCoordinates * 1000);
    // if (timeCoordinates <= 20) {
    //   setInterval(() => {
    //     this.sendUserLocation();
    //   }, 30000);
    // }
  };

  reloadMap = async () => {
    const { baseMaps, layers, map, popupProp, updateLayerMapState } = this.props;
    const { currentLocationState, goToState, aiInterestArea } = this.state;
    const leafletObjectResults = await drawMapLayers({
      layers,
      baseMaps,
      popupProp,
      leafletMap: this.mapMap,
      layersOverlayed: mapOps.areLayersOverlayed(map),
      layersToDisplay: this.layersToDisplay,
      baseMapsToDisplay: this.baseMapsToDisplay,
      isUpdate: true,
      baseMapsTransparency: mapOps.getBaseMapsTransparency(map),
      layersTransparency: mapOps.getLayersTransparency(map),
      baseMapsZoom: mapOps.getBaseMapsZoom(map),
      layersZoom: mapOps.getLayersZoom(map)
    });
    this.layersToDisplay = leafletObjectResults.newLayersToDraw;
    this.baseMapsToDisplay = leafletObjectResults.newBaseMapsToDraw;
    drawCustomButtons({
      map,
      type: 'map',
      leafletMap: this.mapMap,
      layers,
      layersToDisplay: this.layersToDisplay,
      baseMaps,
      baseMapsToDisplay: this.baseMapsToDisplay,
      baseMapsZoom: mapOps.getBaseMapsZoom(map),
      layersZoom: mapOps.getLayersZoom(map),
      reloadButton: true,
      reloadFunction: this.reloadMap,
      locationButton: true,
      currentLocationState,
      locationFunction: this.currentLocation,
      gotoLocationButton: true,
      gotoLocationFunction: this.gotoLocation,
      goToState
    });
    drawMapInterestArea({
      aiInterestArea,
      aiInterestAreaLayer: this.aiInterestAreaLayer,
      isUpdate: true,
      leafletMap: this.mapMap
    });
    if (!isEmpty(aiInterestArea)) {
      this.mapMap.removeControl(this.aiInterestAreaDrawControl);
    }
    if (mapOps.showDrawControl(map)) {
      showGeometryEditControls({
        leafletMap: this.mapMap,
        drawControl: this.aiInterestAreaDrawControl,
        editControl: this.aiInterestAreaEditControl,
        defineGeometryActive: true,
        geometryLayer: this.aiInterestAreaLayer
      });
    }

    if (this.mapMap.collapseButton) this.mapMap.collapseButton.expand();
    updateLayerMapState(false);
    Bert.alert('Map Updated!', 'success');
  };

  async loadClientModules() {
    if (Meteor.isClient) {
      L = await import('leaflet');
      localforage = await import('localforage');
      ({
        addDrawEventListenersMaps,
        createGeometryDrawControlsMaps,
        customHomeButton,
        drawCustomButtons,
        drawMapLayers,
        drawMapInterestArea,
        getBBoxFromCoordsAndZoom,
        getMapCenter,
        showGeometryEditControls
      } = await import('../../../modules/leaflet-operations'));
      this.setState({ clientModulesReady: true });
    }
  }

  render() {
    const {
      baseMaps,
      deployEnv,
      externalBoton,
      isAtlas,
      isFullScreen,
      isPublicMap,
      layers,
      map,
      leafletMapId
    } = this.props;
    const { isMapMapLoaded, mapCenter } = this.state;
    const showBaseMapSelector = mapOps.showBaseMapSelector(map) && !isEmpty(baseMaps);
    const showLayerSelector = mapOps.showLayerSelector(map) && !isEmpty(layers);

    let numberOfButtonsRight = 0;
    if (showBaseMapSelector) numberOfButtonsRight += 1;
    if (showLayerSelector) numberOfButtonsRight += 1;

    const mapId = isAtlas ? this.randomMapId : leafletMapId;
    return (
      <>
        {externalBoton && (
          <ExportProviderMap
            gotoLocation={this.gotoLocation}
            goToCoordinatesFunction={this.goToCoordinatesFunction}
            currentLocation={this.currentLocation}
            mapCenter={mapCenter}
            mapbol={isMapMapLoaded}
            drawGeometriesNotes={this.drawGeometriesNotes}
            drawGeometriesTemplates={this.drawGeometriesTemplates}
            drawToDownload={this.drawToDownload}
            pointOfStreetView={this.pointOfStreetView}
            pointOfNotesMaps={this.pointOfNotesMaps}
          />
        )}

        <LeafletMap
          deployEnv={deployEnv}
          headerType="1"
          isAtlas={isAtlas}
          isFullScreen={isFullScreen}
          mapId={mapId}
          ref={this.mapMapComponent}
          updateMapState={this.updateMapState}
          {...this.props}
        />
        {!isPublicMap && (
          <ButtonOnMap numberOfButtonsRight={numberOfButtonsRight}>
            <div
              onClick={this.updateMapCenter}
              title="Recargar posición inicial del mapa"
              role="button"
              onKeyPress={() => ''}
              tabIndex={0}
            >
              <img
                src="/maps-buttons/flecha_ubicacion.svg"
                style={{ height: '34px', width: '34px', cursor: 'pointer' }}
                alt="Update Map Center"
              />
            </div>
          </ButtonOnMap>
        )}
      </>
    );
  }
}
MapContainerViewMap.defaultProps = {
  popupProp: false,
  externalBoton: false,
  isAtlas: false,
  isFullScreen: false,
  isPublicMap: false,
  updateLayerMapState: () => {},
  updateLocation: () => {},
  userControlSetting: {},
  handleMapLoaded: () => {},
  leafletMapId: 'mapMap'
};

MapContainerViewMap.propTypes = {
  baseMaps: PropTypes.array.isRequired,
  deployEnv: PropTypes.string.isRequired,
  userControlSetting: PropTypes.object,
  externalBoton: PropTypes.bool,
  popupProp: PropTypes.bool,
  isAtlas: PropTypes.bool,
  isFullScreen: PropTypes.bool,
  isPublicMap: PropTypes.bool,
  layers: PropTypes.array.isRequired,
  map: PropTypes.object.isRequired,
  updateLayerMapState: PropTypes.func,
  updateLocation: PropTypes.func,
  handleMapLoaded: PropTypes.func,
  leafletMapId: PropTypes.string
};

export default MapContainerViewMap;
